import type { Letters } from './scoring';

export function containsInOrder(word: string, letters: Letters): boolean {
  let i = 0;
  for (const ch of word) {
    if (ch === letters[i]) {
      i++;
      if (i === letters.length) return true;
    }
  }
  return false;
}
